import { UseFormatPhoneNumber } from '../interfaces';

export const useFormatPhoneNumber: () => UseFormatPhoneNumber = (): UseFormatPhoneNumber => {
  const formatPhone = (phone: string): string => {
    const phoneArrayWithSeparatedNumbers: RegExpMatchArray | null = phone?.match(/.{3}/g) ?? null;
    const formattedPhone: string = phoneArrayWithSeparatedNumbers?.join(' ') ?? '';

    return `(+48) ${formattedPhone}`;
  };

  return { formatPhone  };
};
